import React from 'react';
import { formatDate } from '../../../lib/dateUtils';

const CONF = {
  high: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  medium: 'bg-amber-50 text-amber-700 border-amber-200',
  low: 'bg-slate-100 text-slate-600 border-slate-200',
};
const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
const TYPE_LABEL = { retainer: 'Retainer', non_retainer: 'Non-retainer', standard: 'Standard', service: 'Service' };

export default function CategoryReviewList({ rows, selected, onToggle }) {
  if (!rows.length) return <p className="text-sm text-slate-500 text-center py-10" data-testid="category-review-empty">Nothing to review here</p>;
  return (
    <ul className="divide-y divide-slate-100 border border-slate-200 rounded-xl overflow-hidden" data-testid="category-review-list">
      {rows.map((r) => {
        const on = selected.has(r._id);
        return (
          <li key={r._id}>
            <label className={`flex items-start gap-3 px-3 py-2.5 cursor-pointer transition-colors ${on ? 'bg-fuchsia-50/60' : 'hover:bg-slate-50'}`} data-testid={`category-review-row-${r._id}`}>
              <input type="checkbox" checked={on} onChange={() => onToggle(r._id)} className="w-4 h-4 mt-1 accent-fuchsia-600 shrink-0" data-testid={`category-review-check-${r._id}`} />
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-semibold text-sm text-[#1a1a2e]">{r.invoice_number}</span>
                  <span className="text-xs text-slate-500 truncate max-w-[220px]">{r.client_name}</span>
                  <span className={`text-[10px] font-semibold uppercase tracking-wide px-1.5 py-0.5 rounded-md border ${CONF[r.confidence]}`}>{r.confidence}</span>
                  <span className="text-[10px] px-1.5 py-0.5 rounded-md bg-slate-100 text-slate-600">Now: {TYPE_LABEL[r.current_type] || r.current_type}</span>
                </div>
                <p className="text-xs text-slate-600 mt-0.5 truncate" title={r.description}>{r.description || '—'}</p>
                <p className="text-[11px] text-fuchsia-800 mt-0.5">{r.reasons.join(' · ')}</p>
              </div>
              <div className="text-right shrink-0">
                <p className="text-sm font-semibold tabular-nums">{inr(r.subtotal)}</p>
                <p className="text-[11px] text-slate-500">{r.invoice_date ? formatDate(r.invoice_date) : '—'}</p>
              </div>
            </label>
          </li>
        );
      })}
    </ul>
  );
}
